import { applyEmptyStringsToNulls } from "@/lib/utils/zod";
import { address } from "@/schemas/address";
import { invoiceAddress } from "@/schemas/invoiceAddress";
import { z } from "@/zod";
import { taxIdentificationNumber } from "./commonFields";

const client = z
  .object({
    id: z.string(),
    ref_number: z.coerce.number().nonnegative().optional(),
    name: z.string().min(1),
    tax_number: taxIdentificationNumber,
    code: z.string().min(1),
    regon_number: z
      .string()
      .transform((val) => val.trim())
      .refine(
        (val) => {
          if (val.length === 0) return true;
          const hasValidLength = val.length === 9 || val.length === 14;
          const isNumericOnly = /^\d+$/.test(val);
          return hasValidLength && isNumericOnly;
        },
        { message: "validation.regon.length" },
      )
      .nullish(),
    ...address.shape,
    ...invoiceAddress.shape,
  })
  .omit({
    province: true,
    province_id: true,
  });

export const readClient = client.readonly();
export const writeClient = applyEmptyStringsToNulls(
  client.omit({ id: true, ref_number: true }).shape,
);
